import styled from 'styled-components';
import GymSvg from '../../assets/amenities/gym.svg';

const GymIcon = styled(GymSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default GymIcon;
